import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from './auth/config.service';

@Injectable({
  providedIn: 'root'
})
export class NcdService {

  baseUrl = 'https://yourapiurl/api/'; // change to your API url

  constructor(private http: HttpClient,private configService:ConfigService) {}

  sendCooperativeSummary(id: number): Observable<any> {
    return this.http.get(`${this.configService.getApiUrl()}/Society/SendCooperativeSummaryAsync?societyDetailsId=${id}`);
  }

  softDeleteSocietySummary(id: number): Observable<any> {
    return this.http.get(`${this.configService.getApiUrl()}/Society/SoftDeleteNCDSocietySummary?societyDetailsId=${id}`);
  }

  getSocietyDetailsRegistationNo(payload: any): Observable<any> {
    return this.http.post(`${this.configService.getApiUrl()}/Society/getSocietyDetailsRegistationNo`,payload);
  }
  GetApprovedSocietiesByMonth(month: any): Observable<any> {
    return this.http.post(`${this.configService.getApiUrl()}/Society/GetApprovedSocietiesByMonth/${month}`,{});
  }
  getApprovedSocieties(data: any) {

  return this.http.post<any>(
   `${this.configService.getApiUrl()}/Society/GetApprovedSocieties`,
    data
  );

}


}